import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson50: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.25rem] box-border gap-[6.88rem] text-justify text-[1.56rem] text-gainsboro-100 font-dm-sans">
   <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset"/>
      <div className="self-stretch flex flex-row items-center justify-between text-left text-darkgray font-nunito">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson49"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Pre-Workout Meal
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"https://unityacademy.io/dashboard"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
      </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[4.63rem] max-w-[102.63rem] text-white">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Working out is a great way to stay healthy and fit. But if you want
            to get the most out of your workouts, it's important to eat the
            right foods before and after you exercise.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A pre-workout meal can help you improve your performance, increase
            your energy, and reduce muscle soreness. It can also help you stay
            focused and motivated during your workout.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>Pre-Workout Meal Importance</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When you exercise, your body burns calories for energy. If you
                don't have enough energy, you may not be able to work out as
                hard or as long. This can lead to decreased performance and
                increased muscle soreness.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A pre-workout meal can help you provide your body with the
                energy it needs to exercise. It can also help you prevent muscle
                breakdown and improve your recovery.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>How Much Should You Eat?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The amount of food you should eat before a workout depends on your
            individual needs. A good rule of thumb is to eat enough to feel
            satisfied, but not full.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you're a beginner, you may want to start with a small meal and
            see how you feel. If you're more experienced, you may be able to eat
            a larger meal before your workout.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>When Should You Eat Pre-Workout?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            It is important to eat a pre-workout meal at least 30 minutes before
            your workout. This will give your body time to digest the food and
            absorb the nutrients.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you eat too close to your workout, you may feel nauseous or have
            stomach cramps.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The best foods to eat before a workout are those that are high in
            carbohydrates and protein. Carbohydrates provide your body with
            energy, while protein helps to repair and build muscle.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Some good choices for pre-workout meals include:
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <ul className="m-0 text-[1rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Oatmeal with fruit and nuts</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Oatmeal is a good source of complex carbohydrates, which provide
            your body with sustained energy. Fruit and nuts add fiber and
            healthy fats to the meal, which can help to keep you feeling full
            and satisfied.
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/fuck1@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Yogurt with berries and granola</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Yogurt is a good source of protein and calcium. Berries are a
                good source of antioxidants, and granola adds fiber and healthy
                fats to the meal.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f2@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Whole-wheat toast with peanut butter</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Whole-wheat toast is a good source of complex carbohydrates, and
                peanut butter is a good source of protein. This meal is a quick
                and easy way to get the energy and protein you need before a
                workout.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f3@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Eggs and toast</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Eggs are a good source of protein and healthy fats. Toast is a
                good source of complex carbohydrates. This meal is a good option
                if you are looking for a more substantial pre-workout meal.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f4@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>
                  A smoothie made with fruit, yogurt, and protein powder
                </span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Smoothies are a convenient and easy way to get a pre-workout
                meal. Simply combine your favorite fruits, yogurt, and protein
                powder in a blender and blend until smooth.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f5@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>What To Avoid</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  There are some foods that you should avoid before a workout
                  especially foods that are slow to digest. These foods include:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Foods that are high in fat or sugar</b>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                These foods can cause stomach upset and make you feel sluggish
                during your workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>Foods that are high in fiber</b>
              </span>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Fiber can slow down digestion, which can make you feel full
                  and bloated during your workout.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <b>
                  <span>Foods that are spicy or acidic</span>
                </b>
              </span>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These foods can irritate your stomach and make you feel nauseous
                during your workout.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is important to eat a pre-workout meal at least 30 minutes
                before your workout. This will give your body time to digest the
                food and absorb the nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you eat too close to your workout, you may feel nauseous or
                have stomach cramps.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                Here are some tips for determining when to eat before a workout:
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Consider the intensity and duration of your workout.
                  </b>
                  <span>
                     If you are doing a short, high-intensity workout, you may
                    not need to eat anything before your workout. If you are
                    doing a longer, moderate-intensity workout, you may need to
                    eat a small meal before your workout.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Listen to your body. </b>
                  <span>
                    If you are feeling hungry, eat something before your
                    workout. If you are not feeling hungry, you may not need to
                    eat anything.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Experiment with different times to eat before your workout.
                  </b>
                  <span> See what time works best for you and your body.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some additional tips for eating a pre-workout meal:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Choose foods that are easy to digest.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Avoid foods that are high in fat or sugar.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Drink plenty of water to stay hydrated.</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>
                    Listen to your body and eat until you are satisfied, but not
                    full.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some recipes for pre-workout meals with calories and
                  macros:
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Oatmeal with fruit and nuts</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">Ingredients:</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>1/2 cup oats</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>1 cup water or milk</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>1/2 cup fruit, such as berries, bananas, or mango</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                1 tablespoon nuts, such as almonds, walnuts, or pecans
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">Calories: 300</p>
          <p className="m-0">Protein: 10 grams</p>
          <p className="m-0">Carbohydrates: 50 grams</p>
          <p className="m-0">Fat: 10 grams</p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Yogurt with berries and granola</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">Ingredients:</p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>1 cup yogurt</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                1/2 cup berries, such as blueberries, raspberries, or
                strawberries
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>1/4 cup granola</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">Calories: 250</p>
          <p className="m-0">Protein: 15 grams</p>
          <p className="m-0">Carbohydrates: 35 grams</p>
          <p className="m-0">Fat: 10 grams</p>
        </div>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
        <p className="m-0 text-[1.88rem] text-white">
          <b>Whole-wheat toast with peanut butter</b>
        </p>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Ingredients:</p>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 text-[1rem] pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>2 slices whole-wheat bread</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 tablespoon peanut butter</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Calories: 250</p>
        <p className="m-0">Protein: 10 grams</p>
        <p className="m-0">Carbohydrates: 30 grams</p>
        <p className="m-0">Fat: 15 grams</p>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
        <p className="m-0 text-[1.88rem] text-white">
          <b>Eggs and toast</b>
        </p>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Ingredients:</p>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 text-[1rem] pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>2 eggs</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 slice whole-wheat bread</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>Salt and pepper to taste</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Calories: 300</p>
        <p className="m-0">Protein: 15 grams</p>
        <p className="m-0">Carbohydrates: 20 grams</p>
        <p className="m-0">Fat: 15 grams</p>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
        <p className="m-0 text-[1.88rem] text-white">
          <b>Smoothie made with fruit, yogurt, and protein powder</b>
        </p>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Ingredients:</p>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 text-[1rem] pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 cup fruit, such as berries, bananas, or mango</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 cup yogurt</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 scoop protein powder</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>1 cup milk</span>
          </li>
        </ul>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">Calories: 350</p>
        <p className="m-0">Protein: 20 grams</p>
        <p className="m-0">Carbohydrates: 50 grams</p>
        <p className="m-0">Fat: 10 grams</p>
        <p className="m-0">&nbsp;</p>
        <p className="m-0">
          These are just a few ideas for pre-workout meals. There are many other
          delicious and nutritious options available. By choosing the right
          foods before your workout, you can help your body recover and improve
          your fitness results.
        </p>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"https://unityacademy.io/dashboard"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson50;
